"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewMfaAuthentication extends new_item_1.default {
    constructor(newMfaAuthentication) {
        super();
        this.token = newMfaAuthentication.token;
    }
}
exports.default = NewMfaAuthentication;
//# sourceMappingURL=new-mfaAuthentication.js.map